import { CustomerIOEventTrackingService } from './customer-io.service';
import { MixPanelService } from './mix-panel.service';
import { AppConfig } from '../../shared/config/app-config';
import { Injectable } from '@angular/core';

export interface EventTrackingServiceProvider {
    track(eventName: string, eventData: Record<string, any>): void;
}
@Injectable({
    providedIn: 'root',
})
export class EventTrackingService {
    private providers: EventTrackingServiceProvider[];

    constructor(private config: AppConfig, private customerIOService: CustomerIOEventTrackingService, private mixPanelService: MixPanelService) {
        this.providers = [this.customerIOService, this.mixPanelService];
    }

    trackEvent(eventName: string, eventData: Record<string, any>) {
        this.providers.forEach((trackingProvider) => {
            if (typeof eventData === 'object') {
                eventData.env = this.config.FO_ENVIRONMENT;
            }

            trackingProvider.track(eventName, eventData);
        });
    }
}
